import { useTranslation as useUiTranslation } from "react-i18next";
import uiI18n from '../i18n';
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { LuSearch, LuMessageCircle, LuTrash2, LuHouse } from "react-icons/lu";
import { photoUrl } from "../Variables";
import "./Messaging.css";

export const conversationTitle = (conversation) => conversation?.propertyDetails?.adLabel || conversation?.propertyDetails?.libelle || conversation?.adLabel || uiI18n.t("ui.listing");

export function ConversationPhoto({ conversation }) {
  useUiTranslation();
  const details = conversation?.propertyDetails;
  const source = photoUrl(String(details?.urlImages || "").split(",")[0], details?.folder);
  const [failedSource, setFailedSource] = useState(null);
  return <span className="chat-photo" aria-hidden="true">
    {details?.urlImages && failedSource !== source
      ? <img src={source} alt="" onError={() => setFailedSource(source)} />
      : <LuHouse size={23} />}
  </span>;
}

export default function ConversationList({ allMessages, selectedConversation, setSelectedConversation, handleDeleteConversationForUser }) {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const filtered = useMemo(() => allMessages.filter(item =>
    [conversationTitle(item), item.propertyDetails?.adresse].join(" ").toLocaleLowerCase().includes(search.trim().toLocaleLowerCase())
  ), [allMessages, search]);
  return <div className="chat-sidebar">
    <div className="chat-sidebar-heading">
      <h2>{t("conversations", "Conversations")}</h2><span className="chat-count">{allMessages.length}</span>
    </div>
    <label className="chat-search">
      <LuSearch size={17} aria-hidden="true" />
      <input value={search} onChange={event => setSearch(event.target.value)} placeholder={t("messages.search", "Rechercher une conversation")} aria-label={t("messages.search", "Rechercher une conversation")} />
    </label>
    <nav className="chat-conversations" aria-label={t("conversations", "Conversations")}>
      {filtered.length ? filtered.map(item => {
        const selected = selectedConversation?.conversationId === item.conversationId;
        return <div className={"chat-conversation" + (selected ? " is-selected" : "")} key={item.conversationId}>
          <button type="button" className="chat-conversation-select" aria-current={selected ? "true" : undefined} onClick={() => setSelectedConversation(item)}>
            <ConversationPhoto conversation={item} />
            <span className="chat-conversation-copy"><strong>{conversationTitle(item)}</strong>
              <span>{item.propertyDetails?.isDeleted || item.propertyIsDeleted ? t("messages.deleted_listing", "Annonce supprimée") : item.propertyDetails?.adresse || t("messages.property_discussion", "À propos de cette annonce")}</span>
              <small>{t("messages.open_discussion", "Voir les échanges")}</small>
            </span>
          </button>
          <button type="button" className="chat-delete" aria-label={t("messages.delete_conversation", "Supprimer la conversation") + " : " + conversationTitle(item)} onClick={() => handleDeleteConversationForUser(item.conversationId)}><LuTrash2 size={16} /></button>
        </div>;
      }) : <div className="chat-list-empty"><LuMessageCircle size={28} /><p>{t("messages.no_results", "Aucune conversation trouvée")}</p></div>}
    </nav>
    <p className="chat-sidebar-note"><LuMessageCircle size={15} />{t("messages.discussion_note", "Tous vos échanges, au même endroit.")}</p>
  </div>;
}
